<template lang="pug">
    div.container-loading
        div.search-wrapper
            div.searchbar.stripe.long-stripe
            div.l-flex-row--rev
                div.searchfilter.stripe.small-stripe
        div.content
            div.stripe.medium-stripe.title
            div.stripe.small-stripe.category
            div.stripe.small-stripe.category
            div.stripe.small-stripe.category
        div.content
            div.stripe.medium-stripe.title
            div.stripe.small-stripe.category
            div.stripe.small-stripe.category
            div.stripe.small-stripe.category
        div.content
            div.stripe.medium-stripe.title
            div.stripe.small-stripe.category
            div.stripe.small-stripe.category
            div.stripe.small-stripe.category
</template>

<script>
export default {
    name: 'CriteriaListSpinner'
}
</script>